export function select2Extansion() {
    
    (function ($) {

        var Defaults = $.fn.select2.amd.require('select2/defaults');

        $.extend(Defaults.defaults, {
            dropdownPosition: 'auto'
        });

        var AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody');

        var _positionDropdown = AttachBody.prototype._positionDropdown;

        AttachBody.prototype._positionDropdown = function () {

            var $window = $(window);

            var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
            var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

            var newDirection = null;

            var offset = this.$container.offset();

            offset.bottom = offset.top + this.$container.outerHeight(false);

            var container = {
                height: this.$container.outerHeight(false)
            };

            container.top = offset.top;
            container.bottom = offset.top + container.height;

            var dropdown = {
                height: this.$dropdown.outerHeight(false)
            };

            var viewport = {
                top: $window.scrollTop(),
                bottom: $window.scrollTop() + $window.height()
            };

            var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
            var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

            var css = {
                left: offset.left,
                top: container.bottom
            };

            // Determine what the parent element is to use for calciulating the offset
            var $offsetParent = this.$dropdownParent;

            // For statically positoned elements, we need to get the element
            // that is determining the offset
            if ($offsetParent.css('position') === 'static') {
                $offsetParent = $offsetParent.offsetParent();
            }

            var parentOffset = $offsetParent.offset();

            css.top -= parentOffset.top
            css.left -= parentOffset.left;

            var dropdownPositionOption = this.options.get('dropdownPosition');

            if (dropdownPositionOption === 'above' || dropdownPositionOption === 'below') {

                newDirection = dropdownPositionOption;

            } else {

                if (!isCurrentlyAbove && !isCurrentlyBelow) {
                    newDirection = 'below';
                }

                if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
                    newDirection = 'above';
                } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
                    newDirection = 'below';
                }

            }

            if (newDirection == 'above' ||
                (isCurrentlyAbove && newDirection !== 'below')) {
                css.top = container.top - parentOffset.top - dropdown.height;
            }

            if (newDirection != null) {
                this.$dropdown
                    .removeClass('select2-dropdown--below select2-dropdown--above')
                    .addClass('select2-dropdown--' + newDirection);
                this.$container
                    .removeClass('select2-container--below select2-container--above')
                    .addClass('select2-container--' + newDirection);
            }

            this.$dropdownContainer.css(css);

        };

    })(window.jQuery);

}

export function select2() {

    $('.reciepiesFilter').select2({
        dropdownPosition: 'below',
        dropdownParent: $('.recepiesFilterDropdown')
    });

    $('.select2-product-filting').select2({
        dropdownPosition: 'below',
        dropdownParent: $('.productFiltring')
    }).on('change', function () {
        let current = $(this).find("option:selected"),
            terms = current.data('terms').toString(),
            container = $('.products-category__row');
        terms = terms.split(',');
        if(terms[0] == "all"){
            container.find(".item").show();
        }else {
            container.find(".item").hide();
            for (let i = 0; i < terms.length; i++) {
                container.find("[data-category=" + terms[i] + "]").show();
            }
        }
    });

    $('.cupCountsSelect').select2({
        dropdownPosition: 'below',
        dropdownParent: $('.cupCountsSelectDropdown')
    }).on('change', function () {
        let select = $(this).get(0),
            option = select.options[select.selectedIndex],
            data = $(option).data('info'),
            info = $(this).parents('.what-counts').find(".info");
        info.find(".title").text(data.title);
        info.find(".item").remove();

        let items = [];
        for (let i = 0; i < data.items.length; i++) {
            items.push("<p class='item'>" + data.items[i].name + "</p>");
        }
        info.append(items.join(''));
    });

    $('.postCategoryFilter').select2({
        dropdownPosition: 'below',
        dropdownParent: $('.postCategoryFilterDropdown')
    });

    $('.postDateFilter').select2({
        dropdownPosition: 'below',
        dropdownParent: $('.postDateFilterDropdown')
    });

    $('.locationFilter').select2({
        dropdownPosition: 'below',
        dropdownParent: $('.locationFilterDropdown')
    });

    $('.select2-form').select2({
        dropdownPosition: 'below',
        dropdownParent: $('.formDropdown')
    });

    $('.footerWhereToBuyFilter').select2({
        dropdownPosition: 'below',
        dropdownParent: $('.footerWhereToBuyFilterDropdown')
    }).on("change", function(){
        window.location.href = "/where-to-buy/?state=" + $(this).val() + "#wtb-list";
    });


    $(".download-dropdown-select").select2({
            dropdownPosition: 'below',
            dropdownParent: $('.download-dropdown-select-d')
        }

    ).on('change', function(){
        $(this).parent().find("a").attr("href", $(this).val());
    });

    $(".download-dropdown-custom-select").click(function(e){
        e.stopPropagation();
        $(this).toggleClass("open");
    });

    $(".download-dropdown-holder li").click(function(e){
        e.stopPropagation();
        let dropdown = $(this).parents(".download-dropdown");
        $(this).parent().find("li").removeClass("active");
        $(this).addClass("active");
        dropdown.find("a").attr("href", $(this).data('value'));
        dropdown.find(".download-dropdown-custom-select").removeClass("open").find("span").text($(this).text());
    });
    $(document).click(function () {
        $(".download-dropdown-custom-select").removeClass("open");
    });
}